import Vue from 'vue';
import Vuex from 'vuex';
import officeApi from '../api/office-api';

Vue.use(Vuex);

const initialState = () => {
  return {
    officeInfo: {},
    officeAccountInfo: {},
  };
};

const getters = {
  getOfficeInfo(state) {
    return state.officeInfo;
  },
  getOfficeAccountInfo(state) {
    return state.officeAccountInfo;
  },
};

const mutations = {
  setOfficeInfo(state, officeInfo) {
    state.officeInfo = officeInfo;
  },
  setOfficeAccountInfo(state, officeAccountInfo) {
    state.officeAccountInfo = officeAccountInfo;
  },
};

const actions = {
  async loadOfficeInfo({ commit }) {
    return new Promise((resolve, reject) => {
      commit('setOfficeInfo', {});
      officeApi
        .loadOfficeInfo()
        .then((apiResponse) => {
          let data = apiResponse.data.data.attributes;
          data.is_custom_logo = apiResponse.data.included[0]['attributes']['is_custom_logo'];
          commit('setOfficeInfo', data);
        })
        .catch(() => {
          reject();
        })
        .finally(() => {
          resolve();
        });
    });
  },
  async loadOfficeAccountInfo({ commit }) {
    return new Promise((resolve, reject) => {
      commit('setOfficeAccountInfo', {});
      officeApi
        .loadOfficeAccountInfo()
        .then((apiResponse) => {
          let data = apiResponse.data.data.attributes;
          data.id = apiResponse.data.data.id;
          commit('setOfficeAccountInfo', data);
        })
        .catch(() => {
          reject();
        })
        .finally(() => {
          resolve();
        });
    });
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== 'production',
};
